import PeriodType from "./PeriodType";

function minStringOf(a: string | undefined, b: string | undefined) {
  if (a === undefined) return b;
  if (b === undefined) return a;
  return a < b ? a : b;
}

function maxStringOf(a: string | undefined, b: string | undefined) {
  if (a === undefined) return b;
  if (b === undefined) return a;
  return a > b ? a : b;
}

function minDateOf(a: Date | undefined, b: Date | undefined) {
  if (a === undefined) return b;
  if (b === undefined) return a;
  return a < b ? a : b;
}

function maxDateOf(a: Date | undefined, b: Date | undefined) {
  if (a === undefined) return b;
  if (b === undefined) return a;
  return a > b ? a : b;
}

function reduceData(data: any, reducer: (a: string | undefined, b: string | undefined) => string | undefined) {
  const dataDates =
    data === undefined
      ? undefined
      : data.map((trace: any) => (trace["x"] ? trace["x"].reduce(reducer, undefined) : undefined));
  const dataDate = dataDates === undefined ? undefined : dataDates.reduce(reducer, undefined);
  return dataDate;
}

function stringToDate(dateString: string | undefined) {
  if (dateString === undefined) return undefined;
  const date = new Date(dateString);
  return date;
}

function dateToDateNoTime(date: Date | undefined) {
  return date === undefined ? undefined : new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function periodToXAxisRange(historicalPeriod: PeriodType, futurePeriod: PeriodType | undefined, data: any) {
  const todayDate = new Date();
  const todayNoTimeDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate());

  const minDate = dateToDateNoTime(stringToDate(reduceData(data, minStringOf)));
  const maxDate = dateToDateNoTime(stringToDate(reduceData(data, maxStringOf)));

  function clip([min, max]: [Date | undefined, Date | undefined]) {
    return [maxDateOf(min, minDate), minDateOf(max, maxDate)];
  }

  var start = undefined;
  var end = undefined;

  switch (historicalPeriod) {
    case "Today":
      start = todayNoTimeDate;
      break;
    case "Y/E":
      start = todayNoTimeDate;
      break;
    case "YTD":
      start = new Date(todayDate.getFullYear(), 0, 1);
      break;
    case "1 Yr":
      start = new Date(todayDate.getFullYear() - 1, todayDate.getMonth(), todayDate.getDate());
      break;
    case "2 Yr":
      start = new Date(todayDate.getFullYear() - 2, todayDate.getMonth(), todayDate.getDate());
      break;
    // case "3 Yr":
    //   start = new Date(todayDate.getFullYear() - 3, todayDate.getMonth(), todayDate.getDate());
    //   break;
    case "5 Yr":
      start = new Date(todayDate.getFullYear() - 5, todayDate.getMonth(), todayDate.getDate());
      break;
    case "Max":
      start = undefined;
      break;
    default:
      start = undefined;
  }

  switch (futurePeriod) {
    case "Today":
      end = todayNoTimeDate;
      break;
    case "YTD":
      end = todayNoTimeDate;
      break;
    case "Y/E":
      end = new Date(todayDate.getFullYear(), 11, 31);
      break;
    case "1 Yr":
      end = new Date(todayDate.getFullYear() + 1, todayDate.getMonth(), todayDate.getDate());
      break;
    case "2 Yr":
      end = new Date(todayDate.getFullYear() + 2, todayDate.getMonth(), todayDate.getDate());
      break;
    // case "3 Yr":
    //   end = new Date(todayDate.getFullYear() + 3, todayDate.getMonth(), todayDate.getDate());
    //   break;
    case "5 Yr":
      end = new Date(todayDate.getFullYear() + 5, todayDate.getMonth(), todayDate.getDate());
      break;
    case "Max":
      end = undefined;
      break;
    default:
      end = todayNoTimeDate;
  }

  return clip([start, end]);
}

export default periodToXAxisRange;
